<template>
  <section class="full-width-image-section report-issue gray-bg">
    <div class="container">
      <div v-if="statusMessage" class="status-message">
        {{ statusMessage }}
      </div>

      <!-- Spinner -->
      <div v-if="isLoading" class="spinner"></div>

      <div class="text-center">
        <h1 class="trails-header special-header">Report an Issue</h1>
      </div>
      <form @submit.prevent>
        <!--
        <div class="mb-3">
          <input type="text" class="form-control" placeholder="Your Name" />
        </div>
        <div class="mb-3">
          <input
            type="number"
            class="form-control"
            placeholder="Contact Number"
          />
        </div>
        <div class="mb-3">
          <input type="email" class="form-control" placeholder="Email" />
        </div>
        <div class="mb-3">
          <input
            type="walkissue"
            class="form-control"
            placeholder="Name of walk with issue"
          />
        </div>
        -->
        <div class="mb-3">
          <textarea
            id="issueDescription"
            class="form-control"
            v-model="issueDescription"
            rows="5"
            placeholder="Describe the issue observed..."
          ></textarea>
        </div>

        <div class="text-center upload-picture mb-1">
          Upload picture from phone:
        </div>
        <div class="mb-3">
          <div class="choose-file">
            <input
              type="file"
              id="photoUpload"
              class="file-name form-control"
              placeholder="Choose file:"
              @change="handleFileUpload"
            />
          </div>
        </div>

        <div class="form-group mt-3">
          <button class="btn btn-primary" @click="captureLocation">
            Capture current location
          </button>
          If you are still at the location of the issue, push this button to
          include your location.
          <div v-if="locationCaptured" class="mt-2">
            <p>
              Location captured: {{ currentLocation.latitude }},
              {{ currentLocation.longitude }}
            </p>
          </div>
        </div>

        <button id="btnSave" type="submit" class="btn w-100" @click="saveIssue">
          Submit
        </button>
      </form>
      <p class="text-center alternatively">
        Alternatively please email a detailed desription along with any relevant
        pictures to:<br />
        <a href="mailto:duhallow@irdduhallow.com">duhallow@irdduhallow.com</a>
      </p>
    </div>
  </section>

  <!-- NEWSLETTER SIGNUP -->
  <NewsletterForm />

  <section class="full-width-image-section footer green-sep"></section>
</template>

<script>
import db from "@/db"; // Adjust the path to your IndexedDB setup
import NewsletterForm from "@/components/NewsletterForm.vue";

export default {
  components: {
    NewsletterForm,
  },

  data() {
    return {
      issueDescription: "",
      photo: null,
      currentLocation: null,
      locationCaptured: false,
      statusMessage: "",
      isLoading: false,
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1); // Go back to the previous page
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.photo = file;
      }
    },
    captureLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            this.currentLocation = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            };
            this.locationCaptured = true;
          },
          error => {
            console.error("Geolocation error:", error);
          }
        );
      } else {
        alert("Geolocation is not supported by this browser.");
      }
    },
    async saveIssue() {
      if (!this.issueDescription || !this.issueDescription.trim()) {
        alert("Please describe the issue before submitting.");
        return;
      }

      // Try to include the trail name for context in the email.
      let trailName = "";
      try {
        const cardId = parseInt(this.$route.params.CardId);
        if (!isNaN(cardId)) {
          const cards = await db.cards
            .where("CardId")
            .equals(cardId)
            .toArray();
          if (cards.length > 0) {
            trailName = cards[0].Name || "";
          }
        }
      } catch (error) {
        console.warn("Could not load trail name for issue email:", error);
      }

      const recipient = "duhallow@irdduhallow.com";
      const subject = trailName
        ? `Trail Issue Report - ${trailName}`
        : "Trail Issue Report";

      const lines = [];
      lines.push("Issue reported via the Discover Duhallow app.");
      lines.push("");
      if (trailName) {
        lines.push(`Trail: ${trailName}`);
      }
      lines.push("Description:");
      lines.push(this.issueDescription.trim());
      lines.push("");
      if (this.locationCaptured && this.currentLocation) {
        lines.push(
          `Location: ${this.currentLocation.latitude}, ${this.currentLocation.longitude}`
        );
        lines.push(
          `Map: https://www.google.com/maps/search/?api=1&query=${this.currentLocation.latitude},${this.currentLocation.longitude}`
        );
        lines.push("");
      }
      if (this.photo) {
        lines.push(
          "(I have a photo of the issue - please remind me to attach it to this email.)"
        );
        lines.push("");
      }

      const body = lines.join("\n");
      const mailtoUrl = `mailto:${recipient}?subject=${encodeURIComponent(
        subject
      )}&body=${encodeURIComponent(body)}`;

      // Opens the user's own email app (web or mobile).
      window.location.href = mailtoUrl;
    },
    async sendIssueToAPI(issueData) {
      const formData = new FormData();
      formData.append("description", issueData.description);
      if (issueData.photo) {
        formData.append("photo", issueData.photo);
      }
      if (issueData.latitude && issueData.longitude) {
        formData.append("latitude", issueData.latitude);
        formData.append("longitude", issueData.longitude);
      }
      formData.append("VisitorCardId", issueData.cardId);
      formData.append("timestamp", issueData.timestamp);

      const base64Credentials = btoa("Ian:Ennistymon1!");
      const baseURL = process.env.VUE_APP_API_BASE_URL;
      const response = await fetch(`${baseURL}VisitorCard/ReportIssue`, {
        method: "POST",
        headers: {
          CustomerId: localStorage.getItem("tenantId"), // Replace with actual CustomerId
          Authorization: `Basic ${base64Credentials}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to send issue to API");
      }
    },
    async registerBackgroundSync() {
      if ("serviceWorker" in navigator && "SyncManager" in window) {
        try {
          const registration = await navigator.serviceWorker.ready;
          await registration.sync.register("sync-issues");
        } catch (error) {
          console.error("Error registering background sync:", error);
        }
      } else {
        console.warn("Background sync is not supported in this browser.");
      }
    },
  },
};
</script>

<style scoped>
.container {
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.custom-file-input {
  display: none;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 2.5rem;
  margin-bottom: 0;
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: 2.5rem;
  padding: 0.5rem 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.btn-primary,
.btn-success {
  margin-top: 20px;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mt-3 {
  margin-top: 1rem;
}

.mt-4 {
  margin-top: 1.5rem;
}

#btnSave {
  width: 300px;
  height: 60px;
  font-size: 24px;
}

.status-message {
  margin-top: 20px;
  padding: 10px;
  background-color: #f0f8ff;
  border: 1px solid #b0c4de;
  color: #333;
  font-size: 16px;
  border-radius: 4px;
}

.spinner {
  margin-top: 20px;
  text-align: center;
  font-size: 18px;
}

.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.spinner:before {
  content: "";
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
